export default function NotFound() {
    return <div className="d-flex justify-content-center">
        <h1>404</h1>
    </div>
}